export interface IPercentageProps {
  decimalScale: number;
  fixedDecimalScale: boolean;
}

export default function generateFlexiblePercentageProps(value: number | null = null): IPercentageProps {
  const flexScale = 10;
  const fixedScale = 2;
  let props = {
    decimalScale: flexScale,
    fixedDecimalScale: false,
  };

  if (value) {
    const valueArray = value.toString().split('.');
    const decScale = valueArray[1] ? flexScale : fixedScale;
    props = {
      decimalScale: decScale,
      fixedDecimalScale: !valueArray[1],
    };
  }
  return props;
}
